module.exports = __webpack_public_path__ + "img/loveImg.aea599f8.png";